import {firestore, getBasePath} from "../firebase";
import {addDates, cleanUndefined, mapSnapshot} from "../api";

export const FETCH_ENTRIES = "FETCH_ENTRIES";

export function fetchEntries(params, key) {
    let query = firestore
        .collection(getBasePath() + "/entries");
    if (params.date) {
        query = query.where("date", ">=", params.date.from)
            .where("date", "<=", params.date.to)
    }

    return {
        type: FETCH_ENTRIES,
        meta: {key},
        payload: query
            .get()
            .then(sh => mapSnapshot(sh))
    };
}

// key is check if already fetched.
export function fetchEntriesIfNeeded(params, key) {
    if (!key) {
        throw new Error("Error in EntryActions.fetchEntriesIfNeededlocal: No key provided")
    }
    return (dispatch, state) => {
        const {entries} = state();
        if (!entries.isFetching[key] && !entries.isFetched[key]) {
            dispatch(fetchEntries(params, key));
        }
    };
}

export const FETCH_FILTERED_ENTRIES = "FETCH_FILTERED_ENTRIES";

export function fetchFilteredEntries(params, key) {
    if (!key) {
        throw new Error("Error in EntryActions.fetchEntriesIfNeededlocal: No key provided")
    }


    return (dispatch, state) => {
        const {entries} = state();
        if (entries.isFetching[key] || entries.isFetched[key]) {
            return;
        }

        let query = firestore
            .collection(getBasePath() + "/entries");

        if (params.client_id) query = query.where("client", "==", firestore.doc(getBasePath() + "/clients/" + params.client_id));
        if (params.project_id) query = query.where("project", "==", firestore.doc(getBasePath() + "/projects/" + params.project_id));
        if (params.task_id) query = query.where("task", "==", firestore.doc(getBasePath() + "/tasks/" + params.task_id));
        if (params.user_id) query = query.where("user", "==", firestore.doc("users/" + params.user_id));

        if (params.from) query = query.where("date", ">=", parseInt(params.from.format("YYYYMMDD"), 10));
        if (params.to) query = query.where("date", "<=", parseInt(params.to.format("YYYYMMDD"), 10));

        dispatch({
            type: FETCH_FILTERED_ENTRIES,
            meta: {key},
            payload: query
                .get()
                // .then(o => {console.log(o); window.o = o; return o;})
                .then(sh => mapSnapshot(sh))
        })
    }
}


export const SAVE_ENTRY = "SAVE_ENTRY";

export function saveEntry(params) {

    if (!params || !params.client_id || !params.project_id || !params.task_id || !params.minutes || !params.description || !params.user_id) {
        throw new Error("Error creating entry: params not ok")
    }

    cleanUndefined(params);
    addDates(params);

    params.project = firestore.doc(getBasePath() + "/projects/" + params.project_id);
    params.client = firestore.doc(getBasePath() + "/clients/" + params.client_id);
    params.task = firestore.doc(getBasePath() + "/tasks/" + params.task_id);
    params.user = firestore.doc("users/" + params.user_id);
    delete params.client_id;
    delete params.project_id;
    delete params.task_id;
    delete params.user_id;

    return (dispatch, getState) => {

        if (params.id) {
            //Update
            const {entries} = getState();
            dispatch({
                type: SAVE_ENTRY,
                meta: {user: params.user, previousMinutes: entries.items[params.id].minutes},
                payload: firestore
                    .doc(getBasePath() + "/entries/" + params.id)
                    .update(params)
                    .then(() => params)
            });
        } else {
            //New
            dispatch({
                type: SAVE_ENTRY,
                meta: {previousMinutes: 0},
                payload: firestore
                    .collection(getBasePath() + "/entries")
                    .add(params)
                    .then(sh => mapSnapshot(sh))
            });
        }
    }
}

export const REMOVE_ENTRY = "REMOVE_ENTRY";

export function removeEntry(entryId) {
    return (dispatch, getState) => {
        const {entries} = getState();
        const entry = entries.items[entryId];
        dispatch({
            type: REMOVE_ENTRY,
            meta: {entryId, entry, previousMinutes: entry.minutes},
            payload: firestore
                .doc(getBasePath() + "/entries/" + entryId)
                .delete()
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/EntryActions.js